import { Grid, MenuItem, Select } from "@mui/material";
import { useFormik } from "formik";
import React, { useState } from "react";
import DashboardLayout from "../../Components/LayoutContainers/DashboardLayout";
import MDBox from "../../Components/MDBox";
import MDButton from "../../Components/MDButton";
import MDDivider from "../../Components/MDDivider";
import MDInput from "../../Components/MDInput";
import MDTypography from "../../Components/MDTypography";
import DashboardNavbar from "../../Components/Navbars/DashboardNavbar";
import * as Yup from "yup";
import { ErrorToaast, SuccessToaast } from "../../utils/toast/Toast";
import { v4 as uuid } from "uuid";
import { useNavigate } from "react-router-dom";
import SearchSend from "./components/SearchSend";
import MDDate from "../../Components/MDDate";
import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import { SenfMelkModel } from "../../Api/Models/SenfMelkModel";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteDialog from "./components/DeleteDialog";

const validationSchema = Yup.object().shape({
  ZaribTabaghe: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  ZaribMasahat: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  ShakheAsli: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  ZirShakhe: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  ZaribEthadiye: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  ShomareParvande: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  TarikhSodoor: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  CodeMelki: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  Name: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  LastName: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  FatherName: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  ShomareShenasname: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  ShomareSabet: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  ShomareMobile: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  CodePosti: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  MahalKasb: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  KhiabanFari: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  ZaribPasmand: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  Metraj: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  TabloDetail: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  TabloMetraj: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  Description: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
});
const date = new DateObject({ calendar: persian });

export default function MalekSenf() {
  const [tabagheSelect, setTabagheSelect] = useState("1");
  const [masahatSelect, setmasahatSelect] = useState("24");
  const [searchOpen, setSearchOpen] = useState(false);
  const [SenfId, setSenfId] = useState(0);
  const [searched, setSearched] = useState([]);
  const [editable, setEditable] = useState<number>(0);
  const [deleteOpen, setDeleteOpen] = useState<{ open: boolean; id: number }>({ open: false, id: 0 });

  const navigate = useNavigate();
  const senfMelkModel = new SenfMelkModel();
  const formik = useFormik({
    initialValues: {
      ZaribTabaghe: "1",
      ZaribMasahat: "24",
      ShakheAsli: "",
      ZirShakhe: "",
      ZaribEthadiye: "",
      ShomareParvande: "",
      TarikhSodoor: "",
      CodeMelki: "",
      Name: "",
      LastName: "",
      FatherName: "",
      ShomareShenasname: "",
      ShomareSabet: "",
      ShomareMobile: "",
      CodePosti: "",
      MahalKasb: "",
      KhiabanFari: "",
      ZaribPasmand: "",
      Metraj: "",
      TabloDetail: "",
      TabloMetraj: "",
      Description: "",
      isActive: false,
    },
    onSubmit: (data) => {
      var model;
      if (editable !== 0) {
        if (!data.isActive) {
          ErrorToaast("وضعیت غیر فعال میباشد");
          return;
        }
        model = {
          ShomareParvande: formik.values.ShomareParvande,
          TarikhSodoor: formik.values.TarikhSodoor,
          CodeMelki: formik.values.CodeMelki,
          Name: formik.values.Name,
          LastName: formik.values.LastName,
          FatherName: formik.values.FatherName,
          ShomareShenasname: formik.values.ShomareShenasname,
          ShomareSabet: formik.values.ShomareSabet,
          ShomareMobile: formik.values.ShomareMobile,
          CodePosti: formik.values.CodePosti,
          MahalKasb: formik.values.MahalKasb,
          KhiabanFari: formik.values.KhiabanFari,
          ZaribTabaghe: formik.values.ZaribTabaghe,
          ZaribMasahat: formik.values.ZaribMasahat,
          ZaribPasmand: formik.values.ZaribPasmand,
          Metraj: formik.values.Metraj,
          TabloDetail: formik.values.TabloDetail,
          TabloMetraj: formik.values.TabloMetraj,
          Description: formik.values.Description,
          isActive: formik.values.isActive,
          SenfId: SenfId,
        };
        senfMelkModel
          .EditData({ ...model, id: editable })
          .then((r) => SuccessToaast("با موفقیت ویرایش شد"))
          .then((e) => {
            // ErrorToaast("خطا در برقراری ارتباط");
          });
      } else {
        model = {
          ShomareParvande: data.ShomareParvande.toString(),
          TarikhSodoor: data.TarikhSodoor.toString(),
          CodeMelki: data.CodeMelki.toString(),
          Name: data.Name.toString(),
          LastName: data.LastName.toString(),
          FatherName: data.FatherName.toString(),
          ShomareShenasname: data.ShomareShenasname.toString(),
          ShomareSabet: data.ShomareSabet.toString(),
          ShomareMobile: data.ShomareMobile.toString(),
          CodePosti: data.CodePosti.toString(),
          MahalKasb: data.MahalKasb.toString(),
          KhiabanFari: data.KhiabanFari.toString(),
          ZaribTabaghe: data.ZaribTabaghe.toString(),
          ZaribMasahat: data.ZaribMasahat.toString(),
          ZaribPasmand: data.ZaribPasmand.toString(),
          Metraj: data.Metraj.toString(),
          TabloDetail: data.TabloDetail.toString(),
          TabloMetraj: data.TabloMetraj.toString(),
          Description: data.Description.toString(),
          SenfId: SenfId.toString(),
        };
        senfMelkModel
          .crete(model)
          .then((r) => SuccessToaast("با موفقیت اضافه شد"))
          .then((e) => ErrorToaast("خطا در برقراری ارتباط"));
      }
      formik.resetForm();
      setSenfId(0);
      setEditable(0);
    },
    validationSchema,
    validateOnChange: false,
    validateOnBlur: false,
    validateOnMount: false,
  });
  const handleSearchClick = (data: any) => {
    formik.setFieldValue("ZirShakhe", data.title);
    formik.setFieldValue("ShakheAsli", data.asnafCategory.title);
    formik.setFieldValue("ZaribEthadiye", data.gheymat);
    setSenfId(data.id);
    setSearchOpen(false);
  };
  const handleSearch = () => {
    senfMelkModel
      .GetSearch(
        formik.values.ShomareParvande,
        formik.values.CodeMelki,
        formik.values.Name,
        formik.values.LastName,
        formik.values.FatherName,
        formik.values.ShomareShenasname,
        SenfId.toString()
      )

      .then((r) => {
        setSearched(r.data.data);
      })
      .catch((e) => ErrorToaast("مشکل در برقراری ارتباط"));
  };
  const handleRowClick = (data: any) => {
    formik.setFieldValue("ZaribTabaghe", data.zaribTabaghe);
    formik.setFieldValue("ZaribMasahat", data.zaribMasahat);
    formik.setFieldValue("ShakheAsli", data.senf.title);
    formik.setFieldValue("ShomareParvande", data.shomareParvande);
    formik.setFieldValue("TarikhSodoor", data.tarikhSodoor);
    formik.setFieldValue("CodeMelki", data.codeMelki);
    formik.setFieldValue("Name", data.name);
    formik.setFieldValue("LastName", data.lastName);
    formik.setFieldValue("FatherName", data.fatherName);
    formik.setFieldValue("ShomareShenasname", data.shomareShenasname);
    formik.setFieldValue("ShomareSabet", data.shomareSabet);
    formik.setFieldValue("ShomareMobile", data.shomareMobile);
    formik.setFieldValue("CodePosti", data.codeMelki);
    formik.setFieldValue("MahalKasb", data.mahalKasb);
    formik.setFieldValue("KhiabanFari", data.khiabanFari);
    formik.setFieldValue("ZaribPasmand", data.zaribPasmand);
    formik.setFieldValue("Metraj", data.metraj);
    formik.setFieldValue("TabloDetail", data.tabloDetail);
    formik.setFieldValue("TabloMetraj", data.tabloMetraj);
    formik.setFieldValue("Description", data.description);
    formik.setFieldValue("ZirShakhe", data.senf.title);
    formik.setFieldValue("ZaribEthadiye", data.senf.gheymat);
    setSenfId(data.senfId);
    formik.setFieldValue("isActive", data.isActive);
  };
  const handleEdit = async () => {
    if (editable === 0) return;
    var model = {
      ShomareParvande: formik.values.ShomareParvande,
      TarikhSodoor: formik.values.TarikhSodoor,
      CodeMelki: formik.values.CodeMelki,
      Name: formik.values.Name,
      LastName: formik.values.LastName,
      FatherName: formik.values.FatherName,
      ShomareShenasname: formik.values.ShomareShenasname,
      ShomareSabet: formik.values.ShomareSabet,
      ShomareMobile: formik.values.ShomareMobile,
      CodePosti: formik.values.CodePosti,
      MahalKasb: formik.values.MahalKasb,
      KhiabanFari: formik.values.KhiabanFari,
      ZaribTabaghe: formik.values.ZaribTabaghe,
      ZaribMasahat: formik.values.ZaribMasahat,
      ZaribPasmand: formik.values.ZaribPasmand,
      Metraj: formik.values.Metraj,
      TabloDetail: formik.values.TabloDetail,
      TabloMetraj: formik.values.TabloMetraj,
      Description: formik.values.Description,
      SenfId: SenfId,
    };
    await senfMelkModel
      .EditData({ ...model, id: editable })
      .then((r) => SuccessToaast("با موفقیت ویرایش شد"))
      .then((e) => {
        // ErrorToaast("خطا در برقراری ارتباط");
      });
    setEditable(0);
    setSenfId(0);
    formik.resetForm();
  };
  const handleChangeStatus = () => {
    if (editable === 0) return;

    //handle
    senfMelkModel
      .ChangeStatus(editable)
      .then((result: any) => {
        SuccessToaast("وضعیت با موفقیت تغیر یافت");
        formik.setFieldValue("isActive", !formik.values.isActive);
      })
      .catch((err: any) => {
        ErrorToaast("با مشکل مواجه شد");
      });
  };
  return (
    <DashboardLayout>
      <DashboardNavbar name={"مشخصات مالک صنف"} />
      <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
        <MDBox bgColor="white" borderRadius="5px" p="10px 5px">
          <MDTypography fontWeight="bold" fontSize="14px">
            مشخصات مالک
          </MDTypography>
          <MDDivider />
          <MDBox py={2}>
            <Grid container gap="14px 0" textAlign={"center"}>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">شماره پرونده</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="ShomareParvande"
                    value={formik.values.ShomareParvande}
                    error={formik.touched.ShomareParvande && Boolean(formik.errors.ShomareParvande)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">تاریخ صدور</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDDate
                    name="TarikhSodoor"
                    portal
                    label={""}
                    size="small"
                    defaultValue={date.format("YYYY-MM-DD")}
                    onChange={(e: any) => formik.setFieldValue("TarikhSodoor", e)}
                    value={formik.values.TarikhSodoor}
                    error={formik.touched.TarikhSodoor && Boolean(formik.errors.TarikhSodoor)}
                    helperText={false}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">کد ملی</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    name="CodeMelki"
                    onChange={formik.handleChange}
                    value={formik.values.CodeMelki}
                    error={formik.touched.CodeMelki && Boolean(formik.errors.CodeMelki)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">نام</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="Name"
                    value={formik.values.Name}
                    error={formik.touched.Name && Boolean(formik.errors.Name)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">نام خانوادگی</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="LastName"
                    value={formik.values.LastName}
                    error={formik.touched.LastName && Boolean(formik.errors.LastName)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">نام پدر</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="FatherName"
                    value={formik.values.FatherName}
                    error={formik.touched.FatherName && Boolean(formik.errors.FatherName)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">شماره شناسنامه</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="ShomareShenasname"
                    value={formik.values.ShomareShenasname}
                    error={formik.touched.ShomareShenasname && Boolean(formik.errors.ShomareShenasname)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">شماره تلفن ثابت</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="ShomareSabet"
                    value={formik.values.ShomareSabet}
                    error={formik.touched.ShomareSabet && Boolean(formik.errors.ShomareSabet)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">شماره موبایل</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="ShomareMobile"
                    value={formik.values.ShomareMobile}
                    error={formik.touched.ShomareMobile && Boolean(formik.errors.ShomareMobile)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">کد پستی</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="CodePosti"
                    value={formik.values.CodePosti}
                    error={formik.touched.CodePosti && Boolean(formik.errors.CodePosti)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">محل کسب</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="MahalKasb"
                    value={formik.values.MahalKasb}
                    error={formik.touched.MahalKasb && Boolean(formik.errors.MahalKasb)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">خیابان فرعی</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="KhiabanFari"
                    value={formik.values.KhiabanFari}
                    error={formik.touched.KhiabanFari && Boolean(formik.errors.KhiabanFari)}
                  />
                </Grid>
              </Grid>
            </Grid>
          </MDBox>
        </MDBox>
        <MDBox bgColor="white" borderRadius="5px" p="10px 5px">
          <MDTypography fontWeight="bold" fontSize="14px">
            مشخصات صنف
          </MDTypography>
          <MDDivider />
          <MDBox py={2}>
            <Grid container gap="14px 0" textAlign={"center"}>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">شاخه اصلی صنف</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    disabled
                    size="small"
                    name="ShakheAsli"
                    value={formik.values.ShakheAsli}
                    onChange={() => {}}
                    // error={formik.touched.ShomParvande && Boolean(formik.errors.ShomParvande)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">زیر شاخه صنف</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    disabled
                    size="small"
                    onChange={() => {}}
                    name="ZirShakhe"
                    value={formik.values.ZirShakhe}
                    // error={formik.touched.ShomParvande && Boolean(formik.errors.ShomParvande)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center" justifyContent={"end"}>
                <Grid item width="150px" xs={7}>
                  <MDButton
                    variant="outlined"
                    color="dark"
                    fullWidth
                    onClick={() => {
                      setSearchOpen(true);
                    }}
                  >
                    انتخاب صنف
                  </MDButton>
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">نوع طبقات</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <Select
                    fullWidth
                    size="small"
                    onChange={(e) => {
                      formik.setFieldValue("ZaribTabaghe", e.target.value);
                      setTabagheSelect(e.target.value);
                    }}
                    value={tabagheSelect}
                  >
                    <MenuItem value={1}>بیرون از پاساژ و همکف</MenuItem>
                    <MenuItem value={0.9}>زیرزمین </MenuItem>
                    <MenuItem value={0.95}>طبقات</MenuItem>
                  </Select>
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">مساحت</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <Select
                    fullWidth
                    size="small"
                    onChange={(e) => {
                      formik.setFieldValue("ZaribMasahat", e.target.value);
                      setmasahatSelect(e.target.value);
                    }}
                    value={masahatSelect}
                  >
                    <MenuItem value={24}>از 1 تا 20 متر مربع</MenuItem>
                    <MenuItem value={26}>از 20 تا 30 متر مربع</MenuItem>
                    <MenuItem value={28}>از 30 تا 40 متر مربع</MenuItem>
                    <MenuItem value={31}>از 40 تا 50 متر مربع</MenuItem>
                    <MenuItem value={33}>از 50 تا 70 متر مربع</MenuItem>
                    <MenuItem value={36}>از 70 تا 100 متر مربع</MenuItem>
                    <MenuItem value={48}>بالاتر از 100</MenuItem>
                  </Select>
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">ضریب اتحادیه</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput fullWidth size="small" disabled name="ZaribEthadiye" value={formik.values.ZaribEthadiye} onChange={() => {}} />
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">ضریب طبقه</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    disabled
                    name="ZaribTabaghe"
                    onChange={() => {}}
                    value={formik.values.ZaribTabaghe}
                    error={formik.touched.ZaribTabaghe && Boolean(formik.errors.ZaribTabaghe)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">ضریب مساحت</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    name="ZaribMasahat"
                    disabled
                    onChange={() => {}}
                    value={formik.values.ZaribMasahat}
                    error={formik.touched.ZaribMasahat && Boolean(formik.errors.ZaribMasahat)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">ضریب پسماند</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="ZaribPasmand"
                    value={formik.values.ZaribPasmand}
                    error={formik.touched.ZaribPasmand && Boolean(formik.errors.ZaribPasmand)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">متراژ</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="Metraj"
                    value={formik.values.Metraj}
                    error={formik.touched.Metraj && Boolean(formik.errors.Metraj)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">مشخصات تابلو</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="TabloDetail"
                    value={formik.values.TabloDetail}
                    error={formik.touched.TabloDetail && Boolean(formik.errors.TabloDetail)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">متراژ تابلو</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="TabloMetraj"
                    value={formik.values.TabloMetraj}
                    error={formik.touched.TabloMetraj && Boolean(formik.errors.TabloMetraj)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={6} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">وضعیت</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  {/* <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="Vaziat"
                    value={formik.values.Vaziat}
                    error={formik.touched.Vaziat && Boolean(formik.errors.Vaziat)}
                  /> */}
                  {formik.values.isActive ? (
                    <MDButton fullWidth onClick={handleChangeStatus} variant="outlined" color="success">
                      فعال
                    </MDButton>
                  ) : (
                    <MDButton fullWidth onClick={handleChangeStatus} variant="outlined" color="error">
                      غیر فعال
                    </MDButton>
                  )}
                </Grid>
              </Grid>
              <Grid container item xs={6} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">توضیحات</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="Description"
                    value={formik.values.Description}
                    error={formik.touched.Description && Boolean(formik.errors.Description)}
                  />
                </Grid>
              </Grid>
            </Grid>
          </MDBox>
          <MDBox>
            <Grid container columnGap={4} justifyContent="center" columns={10} mt={4}>
              <Grid item xs={2}>
                <MDButton
                  fullWidth
                  variant="contained"
                  onClick={() => {
                    formik.resetForm();
                    setEditable(0);
                    setSenfId(0);
                  }}
                  color="success"
                >
                  جدید
                </MDButton>
              </Grid>
              <Grid item xs={2}>
                <MDButton fullWidth variant="contained" color="warning" type="submit">
                  ثبت
                </MDButton>
              </Grid>

              <Grid item xs={2}>
                <MDButton fullWidth variant="contained" color="primary" onClick={handleSearch}>
                  جستجو
                </MDButton>
              </Grid>
              <Grid item xs={2}>
                <MDButton
                  fullWidth
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    if (!editable && editable === 0) return;
                    if (!formik.values.isActive) {
                      ErrorToaast("وضعیت غیر فعال میباشد");
                      return;
                    }
                    navigate(`/avarezsenf/${editable}`, { replace: true });
                  }}
                >
                  عوارض
                </MDButton>
              </Grid>
            </Grid>
          </MDBox>
          <MDBox minHeight="40vh" maxHeight="40vh" sx={{ overflow: "auto" }} bgColor="#adaabb" mt={4} border="2px #5b5b5b solid">
            <MDBox bgColor="#eeeeee" px={1} textAlign="center">
              <Grid container columns={11}>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>شماره پرونده</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>نام </MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>نام پدر</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>کد ملی</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>شماره شناسنامه</MDTypography>
                </Grid>
                <Grid item xs={2}>
                  <MDTypography fontSize={"14px"}>نوع صنف</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>ضریب اتحادیه</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>ضریب طبقات</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>ضریب مساحت</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>حذف</MDTypography>
                </Grid>
              </Grid>
            </MDBox>
            {searched.length > 0 &&
              searched.map((data: any, index: number) => {
                return (
                  <MDBox
                    bgColor={index % 2 === 0 ? "#dfdfdf" : "white"}
                    px={1}
                    key={uuid()}
                    textAlign="center"
                    onClick={() => {
                      handleRowClick(data);
                      setEditable(data.id);
                    }}
                    py={1}
                    sx={{ ":hover": { background: "#9185c8" }, cursor: "pointer" }}
                  >
                    <Grid container columns={11}>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"} borderRight={"1px #000 solid"}>
                          {data.shomareParvande ?? ""}
                        </MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"} borderRight={"1px #000 solid"}>
                          {(data.name ?? "") + " " + (data.lastName ?? "")}
                        </MDTypography>
                      </Grid>

                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"} borderRight={"1px #000 solid"}>
                          {data.fatherName ?? ""}
                        </MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"} borderRight={"1px #000 solid"}>
                          {data.codeMelki ?? ""}
                        </MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"} borderRight={"1px #000 solid"}>
                          {data.shomareShenasname ?? ""}
                        </MDTypography>
                      </Grid>
                      <Grid item xs={2}>
                        <MDTypography fontSize={"14px"} borderRight={"1px #000 solid"}>
                          {data.senf.title ?? ""}
                        </MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"} borderRight={"1px #000 solid"}>
                          {data.senf.gheymat ?? ""}
                        </MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"} borderRight={"1px #000 solid"}>
                          {data.zaribTabaghe ?? ""}
                        </MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"} borderRight={"1px #000 solid"}>
                          {data.zaribMasahat ?? ""}
                        </MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDBox
                          onClick={(e: any) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setDeleteOpen({ open: true, id: data.id });
                          }}
                        >
                          <DeleteIcon color="error" />
                        </MDBox>
                      </Grid>
                    </Grid>
                  </MDBox>
                );
              })}
          </MDBox>
        </MDBox>
      </MDBox>
      <DeleteDialog
        open={deleteOpen.open}
        id={deleteOpen.id}
        setClose={() => setDeleteOpen({ id: 0, open: false })}
        onDone={() => {
          setDeleteOpen({ open: false, id: 0 });

          handleSearch();
        }}
      />

      <SearchSend open={searchOpen} setClose={() => setSearchOpen(false)} onDone={undefined} handleClick={(data: any) => handleSearchClick(data)} />
    </DashboardLayout>
  );
}
